var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroTimeLogoNavCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34266",
    "data-name": "Group 34266",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZeroTime_Logo_-_Horizontal",
    "data-name": "ZeroTime Logo - Horizontal",
    transform: "translate(12.002 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34263",
    "data-name": "Group 34263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path37025",
    d: "M60.156,16.485a6.061,6.061,0,0,0-6.061,6.061V50.424a6.061,6.061,0,0,0,6.061,6.061H88.034a6.061,6.061,0,0,0,6.061-6.061V22.545a6.061,6.061,0,0,0-6.061-6.061ZM64.82,29.211V24.566H83.044v4.645L70.8,43.8l-2.756,3.029L71.98,43.8H83.6v4.645H64.4V43.8L76.612,29.211l3.19-3.585L74.91,29.211Z",
    transform: "translate(-54.095 -16.485)",
    fill: "#1f5ff3",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34265",
    "data-name": "Group 34265",
    transform: "translate(5096 -7559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16868",
    "data-name": "Rectangle 16868",
    width: 64,
    height: 52,
    transform: "translate(-5096 7563)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroTimeLogoNavCollapsed);
export default __webpack_public_path__ + "static/media/ZeroTime_Logo_Nav_Collapsed.706c644bc3d64bded2fe16fe27af1a22.svg";
export { ForwardRef as ReactComponent };